<div class="modal-header border">
  <h4 class="modal-title text-primary">Device assignment history</h4>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  @if (assignments$ | async; as assignments;) {
    <div>
      @if (assignments?.length === 0) { There is no device assignment history available for this device. } @else {
        @if (deviceId$ | async; as deviceId) {
          <p>Device id: {{ deviceId }}</p>
        }
        <div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">User</th>
                <th scope="col">Assigned at</th>
                <th scope="col">Category</th>
              </tr>
            </thead>
            <tbody>
              @for (assignment of assignments; track assignment.id) {
                <tr>
                  <td>{{ assignment.assignedBy.name }}</td>
                  <td>{{ $safeNavigationMigration(assignment?.assignedAt) | date }}</td>
                  <td>{{ assignment.categoryDisplayText }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }
</div>